import React from 'react'
import _ from 'lodash'

import FleetItem from './FleetItem'

const RenderItems = ({
  features: featureTypes,
  fleet,
  lang,
  types,
  published,
}) => {
  return _.map(fleet, item => {
    const { _id: id, image, features, published } = item
    if (published) {
      return (
        <FleetItem
          item={item}
          key={id}
          lang={lang}
          types={types}
          featureTypes={featureTypes}
        />
      )
    }
    return null
  })
}

const FleetList = props => {
  const { filter, fleet } = props
  if (filter > 0) {
    const filteredFleet = _.filter(fleet, ['type', `${filter}`])
    const filtered = {
      ...props,
      fleet: filteredFleet,
    }
    return RenderItems(filtered)
  }
  return RenderItems(props)
}

export default FleetList



// WEBPACK FOOTER //
// ./src/components/Fleet/FleetList.js